
const Input = ({
  type = "text",
  placeholder = "",
  value,
  onChange,
  label,
  required = false,
  className = "",
  name, 
}) => {
  return (
    <div className={`flex flex-col ${className}`}>
      {label && <label className="mb-1 font-semibold">{label}</label>}
      <input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        required={required}
        name={name}
        className="border rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-green-500"
      />
    </div>
  );
};

export default Input;
